import { _ as _call_super } from "@swc/helpers/_/_call_super";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _type_of(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from "@faire/web--source/common/makeObservable";
import { Button } from "@faire/web--source/slate/Button";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackFoodAndBeveragePdpProductInfoSectionExpandableClick } from "@faire/web-api--source/events/foodAndBeverage/click/pdpProductInfoSectionExpandable";
import { action, computed, observable } from "mobx";
import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
var CollapsibleContainer = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    _inherits(CollapsibleContainer, _React_Component);
    function CollapsibleContainer(props) {
        _class_call_check(this, CollapsibleContainer);
        var _this;
        _this = _call_super(this, CollapsibleContainer, [
            props
        ]);
        _this.elementRef = /*#__PURE__*/ React.createRef();
        _this.isCollapsed = false;
        _this.setIsCollapsed = function(value) {
            _this.isCollapsed = value;
        };
        _this.toggleCollapsed = function() {
            var _$action = _this.isCollapsed ? "expand" : "collapse";
            if (isLoggedInRetailer()) {
                trackFoodAndBeveragePdpProductInfoSectionExpandableClick("TAGS", _$action);
            }
            _this.setIsCollapsed(!_this.isCollapsed);
        };
        _this.renderContent = function() {
            return _this.isCollapsed ? /*#__PURE__*/ _jsx(CollapsedContainer, {
                $height: _this.props.thresholdHeight,
                children: _this.props.children
            }) : /*#__PURE__*/ _jsx("div", {
                children: _this.props.children
            });
        };
        _this.renderButton = function() {
            if (_this.isCollapsed) {
                return /*#__PURE__*/ _jsx(CollapseButton, {
                    onClick: _this.toggleCollapsed,
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "ksszta",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Show more"
                            }
                        ]
                    })
                });
            }
            if (_this.isPassedThreshold) {
                return /*#__PURE__*/ _jsx(CollapseButton, {
                    onClick: _this.toggleCollapsed,
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "/d9z7V",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Show less"
                            }
                        ]
                    })
                });
            }
            return null;
        };
        makeObservable(_this);
        return _this;
    }
    var _proto = CollapsibleContainer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.isPassedThreshold) {
            this.setIsCollapsed(true);
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ _jsxs("div", {
            ref: this.elementRef,
            children: [
                /*#__PURE__*/ _jsx(Row, {
                    children: this.renderContent()
                }),
                this.renderButton()
            ]
        });
    };
    _create_class(CollapsibleContainer, [
        {
            key: "isPassedThreshold",
            get: function get() {
                if (!this.elementRef.current) {
                    return false;
                }
                var height = this.elementRef.current.getBoundingClientRect().height;
                return height > this.props.thresholdHeight;
            }
        }
    ]);
    return CollapsibleContainer;
}(React.Component);
__decorate([
    observable
], CollapsibleContainer.prototype, "elementRef", void 0);
__decorate([
    observable
], CollapsibleContainer.prototype, "isCollapsed", void 0);
__decorate([
    computed
], CollapsibleContainer.prototype, "isPassedThreshold", null);
__decorate([
    action
], CollapsibleContainer.prototype, "setIsCollapsed", void 0);
CollapsibleContainer = __decorate([
    observer
], CollapsibleContainer);
export { CollapsibleContainer };
var CollapsedContainer = styled.div.withConfig({
    componentId: "sc-7555717c-0"
})([
    "max-height:",
    "px;overflow:hidden;"
], function(props) {
    return props.$height;
});
var CollapseButton = styled(Button).attrs({
    variant: "tertiary"
}).withConfig({
    componentId: "sc-7555717c-1"
})([
    "margin-top:",
    ";"
], getSpacing("1x"));
